<template>
  <v-card class="painel">
    <div>
      <v-card-text>
        <slot></slot>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
export default {};
</script>

<style>
@media (min-width: 700px) {
  .painel {
    padding: 30px;
    margin: 40px auto 60px auto;
    width: 50%;
  }
}

@media (max-width: 700px) {
  .painel {
    padding: 10px;
    margin: 40px auto 60px auto;
    width: 90%;
  }
}
</style>